<template>
    <div class="container-launch-main-data">
        <div v-if="!canAdvance" class="container-launch-main-data-message" v-html="validateForm().message" />

        <div class="container-launch-main-data-header">
            <div class="name-enterprises">
                <ui-input
                    v-model="form.data.name"
                    :required="form.fields.name.required"
                    type="text"
                    label="Nome:"
                    placeholder="digite..."
                />

                <ui-select-v2
                    v-model="form.data.product_id"
                    design="mgb-15 br-all"
                    :data="productOptions"
                    :required="form.fields.product_id.required"
                    :loading="loader.products"
                    label="Empreendimento:"
                    item-label="name"
                    return-value="id"
                    placeholder="Selecione"
                    @input="productSelectHandler"
                />
            </div>

            <div class="date-start-end">
                <ui-datepicker-range
                    v-model="dateInterval"
                    :required="form.fields.date_interval.required"
                    label-start="Data Inicial:"
                    label-end="Data Final:"
                    @input="dateIntervalHandler"
                />
            </div>
        </div>

        <div class="container-launch-main-data-stage-status-folder">
            <div class="title">Etapa e Status para Pasta Aprovada:</div>
            <div class="step-status-select-folder">
                <div class="status-area">
                    <ui-select-v2
                        v-model="form.data.attributes.saleStageDigitalFolder"
                        :data="stageOptions"
                        :required="form.fields.saleStageDigitalFolder.required"
                        :show-footer="false"
                        :loading="loader.stage"
                        design="mgb-15 br-all"
                        return-value="id"
                        placeholder="Selecione"
                        type="text"
                        label="Etapa:"
                        item-label="name"
                        @input="selectStageHandler($event, 'saleStageDigitalFolder')"
                    />
                </div>
                <div class="stage-area">
                    <ui-select-v2
                        v-model="form.data.attributes.saleStatusDigitalFolder"
                        :data="status.saleStageDigitalFolder"
                        :required="form.fields.saleStatusDigitalFolder.required"
                        :disabled="form.fields.saleStatusDigitalFolder.disabled"
                        :show-footer="false"
                        design="mgb-15 br-all"
                        type="text"
                        label="Status:"
                        item-label="name"
                        return-value="id"
                        placeholder="Selecione"
                    />
                </div>
            </div>
        </div>

        <div class="container-launch-main-data-stage-status">
            <div class="step-status-title-subtitle">
                <div class="title">Etapa e Status para novos cadastros</div>
                <div class="subtitle">
                    Selecione a
                    <span class="stage-status">etapa</span>
                    e
                    <span class="stage-status">status</span>
                    para clientes cadastros no dia do lançamento.
                </div>
            </div>

            <div class="step-status-select">
                <div class="stage-area">
                    <ui-select-v2
                        v-model="form.data.attributes.saleStage"
                        :data="stageOptions"
                        :required="form.fields.saleStage.required"
                        :show-footer="false"
                        :loading="loader.stage"
                        design="mgb-15 br-all"
                        placeholder="Selecione"
                        type="text"
                        label="Etapa:"
                        item-label="name"
                        return-value="id"
                        @input="selectStageHandler($event, 'saleStage')"
                    />
                </div>
                <div class="status-area">
                    <ui-select-v2
                        v-model="form.data.attributes.saleStatus"
                        :data="status.saleStage"
                        :required="form.fields.saleStatus.required"
                        :disabled="form.fields.saleStatus.disabled"
                        :show-footer="false"
                        design="mgb-15 br-all"
                        type="text"
                        label="Status:"
                        item-label="name"
                        return-value="id"
                        placeholder="Selecione"
                    />
                </div>
            </div>
        </div>

        <div class="container-launch-main-data-report-data">
            <div class="title">Exibir dados no Relatório:</div>

            <div class="switch-via">
                <ui-switch
                    v-model="form.data.attributes.via_cliente"
                    :checked="form.data.attributes.via_cliente"
                    :required="form.fields.via_cliente.required"
                    label="Via do Cliente"
                    design="xs primary"
                />

                <ui-switch
                    v-model="form.data.attributes.via_caixa"
                    :checked="form.data.attributes.via_caixa"
                    :required="form.fields.via_caixa.required"
                    label="Via do Caixa"
                    design="xs primary"
                />
            </div>
        </div>

        <div class="container-launch-main-data-called-queues">
            <div class="title">Reserva de unidades:</div>

            <div class="called-queues">
                <ui-switch
                    v-model="form.data.attributes.reserveOnlyToCalledCustom"
                    :checked="form.data.attributes.reserveOnlyToCalledCustom"
                    :required="form.fields.reserveOnlyToCalledCustom.required"
                    label="Reserva unidades apenas para clientes que foram chamados."
                    design="xs primary"
                />
            </div>
        </div>

        <div class="container-launch-main-data-payment-configs">
            <div class="title">Configurações de Pagamento:</div>

            <div class="payment-configs-select">
                <div class="parcel-type-area">
                    <ui-select-v2
                        v-model="form.data.attributes.typesOfPayments"
                        :data="paymentTypeOptionsComputed"
                        :required="form.fields.typesOfPayments.required"
                        :show-footer="false"
                        :loading="loader.typesOfPayments"
                        design="mgb-15 br-all"
                        placeholder="Selecione"
                        label="Tipos de Pagamento:"
                        return-value="value"
                        multiple
                    />
                </div>

                <div class="document-area">
                    <ui-select-v2
                        v-model="form.data.attributes.contract_selected"
                        :data="contractModelOptions"
                        :required="form.fields.contract_selected.required"
                        :show-footer="false"
                        :loading="loader.contractSelected"
                        design="mgb-15 br-all"
                        placeholder="Selecione"
                        label="Contrato:"
                        item-label="name"
                        return-value="id"
                        search-event="launch-contract-model"
                        ajax-search
                    />
                </div>
            </div>
        </div>

        <div class="container-launch-main-data-password-manager">
            <div class="input-password-manager">
                <ui-input
                    v-model="form.data.attributes.password"
                    :required="form.fields.password.required"
                    groupicon="fal fa-lock-alt"
                    invertgroup
                    type="password"
                    label="Senha Mestra"
                    size="md"
                />
            </div>

            <div class="text-password-manager">Utilize a senha para aprovar descontos no caixa.</div>
        </div>

        <div class="container-launch-main-data-footer">
            <div class="button-footer">
                <ui-engine
                    :name-button="nameButton"
                    :next="next"
                    :data="form.data"
                    :method="method"
                    :disabled="!canAdvance"
                    step="main-data"
                    service="launchDay"
                    @input="startLoad"
                />
            </div>
        </div>
    </div>
</template>

<script>
	import { uiInput, uiSelectV2, uiDatepickerRange, uiSwitch } from '@/components/ui/form'
	import uiEngine from '../engine'

	import { product, funnel, contractGeneration } from '@/services/axios'

	import { defaultForm } from '../data'
	import { utilMixin } from '@/mixins'

	import { mapActions, mapGetters } from 'vuex'

	const moment = require('moment')
    require('moment/locale/pt-br')

	const lodash = require("lodash")

	export default {
		name: 'ui-launch-create-main-data',

		components: {
			uiInput,
			uiSelectV2,
			uiDatepickerRange,
			uiSwitch,
			uiEngine,
		},

		mixins: [utilMixin],

		data () {
			return {
				form: {
					data: { ...defaultForm() },
					fields: {
						name: {
							required: true,
							disabled: false
						},
						product_id: {
							required: true
						},
						date_interval: {
							required: true
						},
						saleStageDigitalFolder: {
							required: true
						},
						saleStatusDigitalFolder: {
							required: false,
							disabled: false
						},
						saleStage: {
							required: true
						},
						saleStatus: {
							required: false,
							disabled: true
						},
						via_cliente: {
							required: false
						},
						via_caixa: {
							required: false
						},
						reserveOnlyToCalledCustom: {
							required: false
						},
						password: {
							required: true
						},
						contract_selected: {
							required: false
						},
						typesOfPayments: {
							required: false
						}
					}
				},
				productOptions: [],
				teste: null,
				stageOptions: [],
				status: {
					saleStageDigitalFolder: [],
					saleStage: []
				},
				loader: {
					stage: false,
					products: false,
					contractSelected: false,
					typesOfPayments: false
				},
				method: 'create',
				nameButton: 'Criar e Avançar',
				dateInterval: {
					start: '',
					end: ''
				},
				next: { name: 'launch.management.create.servicePoints', index: 0 },
				paymentTypeOptions: [
					{ label: 'Ato', value: 'act' },
                    { label: 'Entrada', value: 'signal' },
                    { label: 'Única', value: 'unique' },
                    { label: 'Valor Fixo', value: 'fixed_value' },
                    { label: 'Mensal', value: 'monthly' },
                    { label: 'Bimestral', value: 'bimonthly' },
                    { label: 'Trimestral', value: 'quarterly' },
                    { label: 'Quadrimestral', value: 'four_monthly' },
                    { label: 'Semestral', value: 'semester' },
                    { label: 'Anual', value: 'yearly' },
                    { label: 'Intermediária', value: 'intermediary' },
                    { label: 'Chaves', value: 'keys' },
                    { label: 'FGTS', value: 'fgts' },
                    { label: 'Financiamento', value: 'financing' },
                    { label: 'Subsídio', value: 'allowance' },
                    { label: 'Bonificação', value: 'bonus' },
                    { label: 'Bem e Direito', value: 'assets_rights' }
				],
				allowedTypes: [],
				contractModelOptions: [],
				contractFilter: {
					perPage: 25,
					search: '',
					page: 1,
					lastPage: 1,
					total: 0
				}
			}
		},

		computed: {
			...mapGetters('launchDay', { config: 'getConfig' }),
            /**
             * Computed property para filtrar os tipos de parcela/série de modo a ocultar
             * os tipos não permitidos de acordo com a etapa 2
             */
            paymentTypeOptionsComputed() {
                return this.paymentTypeOptions.filter(type => {
                    return this.allowedTypes.length ? this.allowedTypes.includes(type.value) : true
                })
            },
			/**
			 * Computed property que define se o formulário está corretamente preenchido e
			 * pode-se avançar no cadastro do lançamento
			 */
			canAdvance() {
				return this.validateForm().valid
			}
		},

		created() {
			this.$root.$on('select-v2-ajax-search-launch-contract-model', (payload) => {
				this.contractFilter.search = payload.search
				if (payload.nextPage && (this.contractFilter.page < this.contractFilter.lastPage)) {
					this.contractFilter.page += 1

				} else if (!payload.nextPage) {
					this.contractFilter.page = 1
					this.contractFilter.lastPage = 1
				}
				this.loadContractModels()
			})
		},

		mounted() {
			this.loadForm()
		},

		beforeDestroy() {
			this.$root.$off('select-v2-ajax-search-launch-contract-model')
		},

		methods: {
			...mapActions('launchDay', ['setPreLoad']),
			/**
			 * Valida a propriedade required dos campos do formulário
			 */
			validateRequired(field, dataField = '') {
				if (!Object.prototype.hasOwnProperty.call(this.form.fields, field)) {
					throw new Error(`Falha ao validar o campo ${field}. Este campo não existe!`)
				}

				dataField = dataField || field
				const required = this.form.fields[field].required
				const validation = lodash.get(this.form.data, dataField) ||
					parseInt(lodash.get(this.form.data, dataField)) === 0

				return (required && validation) || !required
			},
			/**
			 * Valida os campos do formulário de acordo com diferentes conjuntos de regras
			 */
			validateForm() {
				let valid = true
				let message = '<ul>'
				try {
					if (!this.validateRequired('name')) {
						valid = false
						message += '<li>É necessário definir um nome para o lançamento.</li>'
					}

					if (!this.validateRequired('product_id')) {
						valid = false
						message += '<li>É necessário selecionar um empreendimento para o lançamento.</li>'
					}

					if (!this.validateRequired('date_interval', 'date')) {
						valid = false
						message += '<li>É necessário selecionar data inicial do lançamento.</li>'
					}

					if (!this.validateRequired('date_interval', 'date_end')) {
						valid = false
						message += '<li>É necessário selecionar data final do lançamento.</li>'
					}

					if (!this.validateRequired('saleStageDigitalFolder', 'attributes.saleStageDigitalFolder')) {
						valid = false
						message += '<li>É necessário selecionar uma etapa de pasta aprovada.</li>'
					}

					if (!this.validateRequired('saleStatusDigitalFolder', 'attributes.saleStatusDigitalFolder')) {
						valid = false
						message += '<li>É necessário selecionar um status de pasta aprovada.</li>'
					}

					if (!this.validateRequired('saleStage', 'attributes.saleStage')) {
						valid = false
						message += '<li>É necessário selecionar uma etapa para os novos clientes.</li>'
					}

					if (!this.validateRequired('saleStatus', 'attributes.saleStatus')) {
						valid = false
						message += '<li>É necessário selecionar um status para os novos clientes.</li>'
					}

					if (!this.validateRequired('via_cliente', 'attributes.via_cliente')) {
						valid = false
						message += '<li>É necessário informar se será impressa a via do cliente dos comprovantes de pagamento.</li>'
					}

					if (!this.validateRequired('via_cliente', 'attributes.via_caixa')) {
						valid = false
						message += '<li>É necessário informar se será impressa a via do caixa dos comprovantes de pagamento.</li>'
					}

					if (!this.validateRequired('reserveOnlyToCalledCustom', 'attributes.reserveOnlyToCalledCustom')) {
						valid = false
						message += `<li>É necessário informar se o controle de reservas será disponibilizado
							apenas aos que já passaram pelo controle de chamado.</li>`
					}

					if (!this.validateRequired('password', 'attributes.password')) {
						valid = false
						message += '<li>É necessário informar uma senha para o lançamento.</li>'
					}

					if (!this.validateRequired('contract_selected', 'attributes.contract_selected')) {
						valid = false
						message += '<li>É necessário selecionar um contrato para o controle de pagamento.</li>'
					}

					if (!this.validateRequired('password', 'attributes.typesOfPayments')) {
						valid = false
						message += '<li>É necessário selecionar os tipos de parcelas das simulações a serem consideradas no pagamento.</li>'
					}

				} catch (e) {
					this.$toastr.e(e)
					valid = false
				}
				message += '</ul>'

				return { valid, message }
			},
			/**
			 * Event handler para quando um intervalo for selecionado para a data do lançamento
			 */
			dateIntervalHandler(event) {
				this.form.data.date = event.start
				this.form.data.date_end = event.end
			},
			/**
			 * Event handler que trata o evento de quando o salvamento da página ocorreu com sucesso
			 * e deseja-se ir para a próxima página
			 */
			startLoad() {
				this.$root.$emit('stop-load-launchday', true)
			},
			/**
			 * Event handler que trata o evento de quando uma etapa é selecionada, seja para a
			 * Pasta Digital ou  para os novos clientes cadastrados
			 */
			selectStageHandler(value, name) {
				const stage = this.stageOptions.find(option => parseInt(option.id) === parseInt(value))
				this.status[name] = stage && stage.status ? [...stage.status] : []

				if (this.status[name] && this.status[name].length) this.form.data.attributes[name] = value

				if (name === 'saleStageDigitalFolder') {
					const status = this.status[name].find(status => status.id === this.form.data.attributes.saleStatusDigitalFolder)
					this.form.data.attributes.saleStatusDigitalFolder = status ? status.id : null
					this.form.fields.saleStatusDigitalFolder.disabled = !this.$mx_hasValue(this.status.saleStageDigitalFolder)

				} else if (name === 'saleStage') {
					const status = this.status[name].find(status => status.id === this.form.data.attributes.saleStatus)
					this.form.data.attributes.saleStatus = status ? status.id : null
					this.form.fields.saleStatus.disabled = !this.$mx_hasValue(this.status.saleStage)
				}
			},
			/**
			 * Carrega os dados dos modelos de contrato para o select, inclusive com paginação
			 * no scroll
			 */
			loadContractModels() {
				this.loader.contractSelected = true
				contractGeneration.dataTable({ ...this.contractFilter })
					.then(response => {
						this.contractModelOptions = [...response.data.data]
						this.contractFilter.total = response.data.recordsTotal || 0
						this.contractFilter.lastPage = Math.ceil(this.contractFilter.total / this.contractFilter.perPage)
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log(error)
					})
					.finally(() => {
						this.loader.contractSelected = false
					})
			},
			/**
			 * Event handler que trata o evento de quando um produto/empreendimento é selecionado
			 */
			productSelectHandler() {
				if (!(this.form.data && this.form.data.product_id)) return

				this.allowedTypes = []
				this.loader.typesOfPayments = true
				product.getLimitedTableFlow(this.form.data.product_id, null)
					.then(response => {
						const product = { ...response.data }
						if (product && product.availability) {
							if (product.availability.infos &&
								product.availability.infos.sales_table &&
								product.availability.infos.sales_table.parcel_type) {
								this.allowedTypes = [...product.availability.infos.sales_table.parcel_type]
							}
							this.form.data.availability_id = product.availability.id
						}
						
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
					.finally(() => {
						this.loader.typesOfPayments = false
					})
			},
			/**
			 * Carrega os dados necessários para montar o formulário
			 */
			loadForm: async function () {
				this.loader.products = true
				this.loader.stage = true
				this.setPreLoad(true)
				try {
					// Carrega as opções do select de empreendimento
					let response = await product.getProductWithoutAvailable()
					this.productOptions = [...response.data]

					// Carrega as opções do select de etapa
					response = await funnel.getStages()
					this.stageOptions = [...response.data]

					// Carrega as opções do select de modelos de contrato
					this.loadContractModels()

					// Seta as informações do formulário
					this.form.data = this.config ? { ...this.config } : { ...defaultForm() }
					if (this.form && this.form.data.id) {
						this.method = 'update'
						this.nameButton = 'Atualizar e Avançar'

						for (const attr in this.form.data.attributes) {
							if (attr.toLowerCase().includes('stage') && this.form.data.attributes[attr] !== '') {
								const stage = this.stageOptions.find(option => {
									return parseInt(option.id) === parseInt(this.form.data.attributes[attr])
								})
								this.status[attr] = stage && stage.status ? [...stage.status] : []
							}
						}
					}

					this.dateInterval = { start: '', end: '' }
					if (this.form.data && this.form.data.date && this.form.data.date_end) {
						this.dateInterval = {
							start: moment(this.form.data.date).add(1, 'days').format('YYYY-MM-DD'),
							end: moment(this.form.data.date_end).add( 1, 'days').format('YYYY-MM-DD')
						}
					}

					// Carrega as opções do select de tipos de pagamento/parcelas
					this.productSelectHandler(this.form.data.product_id)

				} catch (error) {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					console.log(error)

				} finally {
					this.loader.products = false
					this.loader.stage = false
					this.setPreLoad(false)
				}
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>